import React from 'react'
import {Navbar,Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft,faEdit} from '@fortawesome/free-solid-svg-icons'
import GlobalStorage from '../storage/GlobalStorage';
import AppZipCreator from'../../AppZipCreator'
import AppConnector from'../../AppConnector'
import AppBlobCache from'../../AppBlobCache'
import JSZip from 'jszip';


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
    this.GS = new GlobalStorage();
    this.connector = new AppConnector();
  }

  render()
  {
    return (
        <div>
          <Navbar color="dark" dark expand="md" className="text-white fixed-top">
              <Button className="mr-2" onClick={()=>{
                if (window.confirm("如想保留存檔，請按【保存及下載】，並保留json檔作下次更新之用。\n請按確認往上一頁。")) { 
                  this.connector.listStoryEpisode(
                    ()=>{
                      this.props.switchMenu('Story');
                      this.props.switchMain('Story');
                    }
                  );              
                }
              }}>
                <FontAwesomeIcon icon={faArrowLeft}/>
              </Button> 
              
              <span className="mr-2">{this.GS.getStory().storyName} - {this.GS.getStoryEpisode().sequence} - {this.GS.getStoryEpisode().project_name} </span>
              {(!this.GS.getStory().channel)?
              <span className="btn m-0 p-0"  onClick={()=>{
              this.props.toggleModalState('createEpisode',2);
              this.props.toggleModal(true);
              }}>
                <FontAwesomeIcon icon={faEdit}/>
              </span>:null}
                
              <div class="navbar-nav flex-row ml-md-auto d-none d-md-flex"></div>
              {(!this.GS.getStory().channel)?
              <Button className="btn btn-primary d-none d-lg-inline-block mb-3 mb-md-0 ml-md-1" href="#"
                onClick={()=>{
                  new AppZipCreator().fulfillZipWithJSON(new JSZip(),
                  [],
                  new AppBlobCache().getMediaBlobs(),
                  Object.assign({}, this.GS.getStoryEpisode()),
                  this.GS.getStoryEpisode().project_name);
                }}
              >保存和下載</Button>:null}

              {(!this.GS.getStory().channel)?
              <Button className="btn btn-primary d-none d-lg-inline-block mb-3 mb-md-0 ml-md-1" href="#"
                onClick={()=>{
                  this.props.toggleModalState('preview');
                  this.props.toggleModal(true);
                }}
              >預覽</Button>:null}

              {(!this.GS.getStory().channel)?
              <Button className="btn btn-primary d-none d-lg-inline-block mb-3 mb-md-0 ml-md-1" href="#"
                onClick={()=>{                                 
                    if (this.GS.getUser().reader.email=='')
                    {
                      this.props.toggleModalState('updateProfile');
                      this.props.toggleModal(true);
                    }else if (this.GS.getStoryEpisode().coverImage==null)
                    {
                      /*alert("請先選擇章節封面");
                      this.props.toggleModalState('createEpisode',2);
                      this.props.toggleModal(true);*/

                      function dataURItoBlob(dataURI) {
                        // convert base64/URLEncoded data component to raw binary data held in a string
                        var byteString;
                        if (dataURI.split(',')[0].indexOf('base64') >= 0)
                          byteString = atob(dataURI.split(',')[1]);
                        else
                          byteString = unescape(dataURI.split(',')[1]);
                        // separate out the mime component
                        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                        // write the bytes of the string to a typed array
                        var ia = new Uint8Array(byteString.length);
                        for (var i = 0; i < byteString.length; i++) {
                          ia[i] = byteString.charCodeAt(i);
                        }
                        return new Blob([ia], {type:mimeString});
                      }

                      var blob;
                      switch (this.GS.getStory().category){
                        case "ROMANCE":
                          blob = dataURItoBlob(global.ROMANCE);
                        break;
                        case "SCIENCE_FICTION":
                            blob = dataURItoBlob(global.SCIENCE_FICTION);
                        break;
                        case "MYSTERY":
                            blob = dataURItoBlob(global.MYSTERY);
                        break;
                        case "COMEDY":
                            blob = dataURItoBlob(global.COMEDY);
                        break;
                        case "HORROR":
                            blob = dataURItoBlob(global.HORROR);
                        break;
                        case "CHINESE_MARTIAL":
                            blob = dataURItoBlob(global.CHINESE_MARTIAL);
                        break;

                      

                      }

                      const file = new File([blob], "capture.jpg", {
                          type: 'image/jpg'
                      });
                      
                      this.GS.getStoryEpisode().coverImage = file;

                      new AppZipCreator().createEpisode(()=>{
                        alert("你的故事一般會在十五分鐘後上架。");
                      });
        
                    }else
                    {
                      new AppZipCreator().createEpisode(()=>{
                        alert("你的故事一般會在十五分鐘後上架。");
                      });
                    }
                }}
              >發佈</Button>:null}
            
          </Navbar>
        </div>
    )
  }
}